import React, { useEffect, useMemo, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

/** Divide uma lista que já está na tela em páginas (as listas longas deixavam a página com dezenas de telas de rolagem). */
export function usePaginas(lista, porPagina = 20) {
  const total = (lista || []).length;
  const paginas = Math.max(1, Math.ceil(total / porPagina));
  const [pagina, setPagina] = useState(1);
  useEffect(() => { if (pagina > paginas) setPagina(paginas); }, [pagina, paginas]);
  const itens = useMemo(() => (lista || []).slice((pagina - 1) * porPagina, pagina * porPagina), [lista, pagina, porPagina]);
  return { pagina, setPagina, paginas, itens, total, porPagina };
}

/** Números das páginas com "…" no meio quando são muitas: 1 … 4 5 6 … 20 */
function numeros(pagina, paginas) {
  const set = new Set([1, paginas, pagina - 1, pagina, pagina + 1].filter((n) => n >= 1 && n <= paginas));
  const ord = [...set].sort((a, b) => a - b), out = [];
  ord.forEach((n, i) => { if (i && n - ord[i - 1] > 1) out.push("…" + n); out.push(n); });
  return out;
}

export function Paginacao({ pagina, setPagina, paginas, total, porPagina, rotulo = "itens", subir = true, className = "" }) {
  if (paginas <= 1) return null;
  const ir = (n) => { setPagina(n); if (subir) window.scrollTo({ top: 0, behavior: "smooth" }); };
  const de = (pagina - 1) * porPagina + 1, ate = Math.min(total, pagina * porPagina);
  const btn = "h-9 min-w-[2.25rem] px-2.5 rounded-lg text-sm font-semibold grid place-items-center transition-colors";
  return (
    <div className={`flex flex-wrap items-center justify-between gap-3 ${className}`} data-testid="paginacao">
      <span className="text-sm text-slate-500">Mostrando <b className="text-slate-800">{de.toLocaleString("pt-BR")}–{ate.toLocaleString("pt-BR")}</b> de <b className="text-slate-800">{total.toLocaleString("pt-BR")}</b> {rotulo}</span>
      <div className="flex items-center gap-1">
        <button type="button" onClick={() => ir(pagina - 1)} disabled={pagina === 1} className={`${btn} border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 disabled:opacity-40`} aria-label="Página anterior"><ChevronLeft className="h-4 w-4" /></button>
        {numeros(pagina, paginas).map((n) => typeof n === "string"
          ? <span key={n} className="px-1 text-slate-400">…</span>
          : <button type="button" key={n} onClick={() => ir(n)} className={`${btn} ${n === pagina ? "bg-[#232D4F] text-white shadow-[0_6px_14px_-8px_rgba(26,35,64,.7)]" : "text-slate-600 hover:bg-slate-100"}`}>{n}</button>)}
        <button type="button" onClick={() => ir(pagina + 1)} disabled={pagina === paginas} className={`${btn} border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 disabled:opacity-40`} aria-label="Próxima página"><ChevronRight className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
